module.exports = __webpack_public_path__ + "img/logo-new.6ef8a99c.svg";